// @flow

import React, { PureComponent } from 'react';

import apiFetch from '../../utils/apiFetch';
import { getTranslationCatalog } from '../../utils/i18n';
import SearchContext from '../../utils/searchContext';
import type { SearchContainerState } from '../../utils/types';
import Vocabulary from '../../utils/vocabulary';

type CollectionSearchContainerProps = {
  collectionUrl: string,
  vocabularyDomain: String,
  vocabularyNames: Array,
  translationsDomain: String,
};

class CollectionSearchContainer extends PureComponent<
  CollectionSearchContainerProps,
  SearchContainerState,
> {
  constructor() {
    super();

    this.setFilters = (newFilters) => {
      let { filters } = this.state;

      // always clean batching
      delete filters.b_start;

      Object.keys(newFilters).forEach((key) => {
        const value = newFilters[key];
        if (value || value.length > 0) {
          filters[key] = value;
        } else {
          if (Object.prototype.hasOwnProperty.call(filters, key)) {
            delete filters[key];
          }
        }
      });
      apiFetch({
        url: this.props.collectionUrl,
        params: filters,
        method: 'GET',
        restApi: true,
      }).then(({ data }) => {
        this.setState({
          ...this.state,
          filters,
          results: data.items,
          batching: data.batching,
        });
      });
    };

    this.state = {
      results: [],
      portalType: [],
      batching: { numpages: 0, current_page: 0, pagesize: 0 },
      translations: {},
      filters: { fullobjects: true },
      setFilters: this.setFilters,
      vocabulary: {},
    };
  }

  getPortalTypeFromQuery = (data: any): Array<string> => {
    let portalType = [];
    data.query.forEach((criteria) => {
      if (criteria.i === 'portal_type') {
        portalType = criteria.v;
      }
    });
    return portalType;
  };

  componentDidMount() {
    //console.log(this.props.collectionUrl);
    const fetches = [
      apiFetch({
        url: this.props.collectionUrl,
        params: this.state.filters,
        method: 'GET',
        restApi: true,
      }),
      getTranslationCatalog(this.props.translationsDomain),
      Vocabulary.getVocabularies(
        this.props.vocabularyDomain,
        this.props.vocabularyNames
      ),
    ];
    Promise.all(fetches).then((data) => {
      const [results, translations, vocabulary] = data;
      const searchResults = results ? results.data : { items: [] };
      this.setState({
        ...this.state,
        portalType: this.getPortalTypeFromQuery(searchResults),
        results: searchResults.items,
        batching: searchResults.batching,
        translations,
        vocabulary,
      });
    });
  }

  render() {
    return (
      <SearchContext.Provider value={this.state}>
        <div className="courses-search-results">{this.props.children}</div>
      </SearchContext.Provider>
    );
  }
}

export default CollectionSearchContainer;
